import React, { useEffect, useState } from 'react';
import { Card, Form, Row, Col, Button, Spinner, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from '../../../api/axios';

const BirthdayCoupon = ({ levels }) => {
    const accessToken = localStorage.getItem('authToken');
    const [inputData, setInputData] = useState({
        level: '',
        type: '',
        couponData: '',
    });
    const [isLoading, setIsLoading] = useState(false);
    const [couponData, setCouponData] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        setIsFormValid(
            inputData.level !== '' && 
            inputData.type !== '' && 
            (inputData.type === 'REWARD' || inputData.couponData !== '')
        );
    }, [inputData]);

    const fetchCouponData = async () => {
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axios.get('settings', { headers });
            if (response?.data?.status === true) {
                setCouponData(response?.data?.data?.settings?.couponInfo?.coupon);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.error || "Failed to fetch coupon data";
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 3000,
                theme: 'colored',
            });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const payload = { ...inputData };
            if (payload.type === 'REWARD') delete payload.couponData;

            const response = await axios.post('level-reward', payload, { headers });
            if (response?.data?.status === true) {
                toast.success(response.data.data.message, {
                    position: 'top-right',
                    autoClose: 3000,
                    theme: 'colored',
                });
                setInputData({ level: '', type: '', couponData: '' });
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.error?.message || 
                               error?.response?.data?.error || 
                               "Something went wrong";
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 3000,
                theme: 'colored',
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCouponData();
    }, []);

    return (
        <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white border-bottom-0 pb-0">
                <Row>
                    <Col className='p-1'>
                        <div className='d-flex'>
                            <h5 className="fw-bold">BIRTHDAY REWARD</h5>
                            <p className="text-muted ms-2 mb-0">(Configure birthday rewards for loyalty levels)</p>
                        </div>
                    </Col>
                    <hr className='mt-0' />

                </Row>
            </Card.Header>
            <Form onSubmit={handleSubmit}>
                <Card.Body className="pt-0">
                    <Row className="gy-3">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Level <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="level"
                                    value={inputData.level}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select level</option>
                                    {levels.map(level => (
                                        <option key={level._id} value={level._id}>
                                            {level.title}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Reward Type <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="type"
                                    value={inputData.type}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select type</option>
                                    <option value="COUPON">Coupon</option>
                                    <option value="REWARD">Reward</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Coupon <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="couponData"
                                    value={inputData.couponData}
                                    onChange={handleChange}
                                    disabled={inputData.type === 'REWARD'}
                                    className="form-select"
                                >
                                    <option value="">Select coupon</option>
                                    {couponData?._id && (
                                        <option value={couponData._id}>{couponData.title}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer className="bg-white border-top-0 pt-0 text-end">
                    <Button 
                        variant="primary" 
                        type="submit" 
                        disabled={!isFormValid || isLoading}
                        className="px-4 py-2"
                    >
                        {isLoading ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" className="me-2" />
                                Saving...
                            </>
                        ) : 'Save Configuration'}
                    </Button>
                </Card.Footer>
            </Form>
        </Card>
    );
};

export default BirthdayCoupon;